export default {"src":"/_next/static/media/git.7c2baeca.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};